"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mobilePromoSagas = exports.mobilePromoUpdateDownloadLink = exports.mobilePromoClose = exports.mobilePromoShowOncePerDay = exports.getMobilePromoKey = exports.getDownloadLink = exports.getTestTrackingId = exports.getTestVersionKey = void 0;
var MobilePromoAction_1 = require("@/pages/common/actions/MobilePromoAction");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var effects_1 = require("redux-saga/effects");
var StorageApi_1 = require("@/api/browser/StorageApi");
var Pages_1 = require("@/rendering/common/Pages");
exports.getTestVersionKey = function (state) { return state.mobilepromo.testVersionId; };
exports.getTestTrackingId = function (state) { return state.mobilepromo.testTrackingId; };
exports.getDownloadLink = function (state) { return state.mobilepromo.downloadLink; };
exports.getMobilePromoKey = function (state) { return state.page === Pages_1.Pages.SEARCH ? 'mobilepromo-inline' : 'mobilepromo-popup'; };
exports.mobilePromoShowOncePerDay = function () {
    var mobilePromoKey, lastSeenStr;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(exports.getMobilePromoKey)];
            case 2:
                mobilePromoKey = _a.sent();
                return [4 /*yield*/, effects_1.call(StorageApi_1.readCookie, mobilePromoKey)];
            case 3:
                lastSeenStr = _a.sent();
                if (!(!lastSeenStr || Number(new Date()) - Number(new Date(lastSeenStr)) > 1000 * 60 * 60 * 24)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(MobilePromoAction_1.default.setIsActive(true))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
exports.mobilePromoClose = function () {
    var mobilePromoKey;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(MobilePromoAction_1.default.CLOSE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(exports.getMobilePromoKey)];
            case 2:
                mobilePromoKey = _a.sent();
                return [4 /*yield*/, effects_1.put(MobilePromoAction_1.default.setIsActive(false))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
exports.mobilePromoUpdateDownloadLink = function () {
    var trackingId, testTrackingId, downloadLink, newDownloadLink;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(StorageApi_1.readCookie, 'oktid')];
            case 2:
                trackingId = _a.sent();
                return [4 /*yield*/, effects_1.select(exports.getTestTrackingId)];
            case 3:
                testTrackingId = _a.sent();
                return [4 /*yield*/, effects_1.select(exports.getDownloadLink)];
            case 4:
                downloadLink = _a.sent();
                newDownloadLink = downloadLink + "?tid=" + testTrackingId + (trackingId ? "&oktid=" + trackingId : '');
                return [4 /*yield*/, effects_1.put(MobilePromoAction_1.default.setDownloadLink(newDownloadLink))];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
exports.mobilePromoSagas = {
    mobilePromoUpdateDownloadLink: exports.mobilePromoUpdateDownloadLink,
    // mobilePromoSetShownOnLoaded,
    // mobilePromoShowOncePerDay,
    mobilePromoClose: exports.mobilePromoClose,
};
